<template>
  <div :class="`header-${device}`">
    <div id="header">
      <header class="header" v-if="device == 'pc'">
        <div class="container">
          <div class="logo">
            <img
              :src="'static/images/pc/loginlogo.png'"
              class="logoImg pointer"
              alt
              @click="toindex"
            />
          </div>
          <div class="nav">
            <ul>
              <li
                v-for="(item, index) in nav"
                :key="index"
                :class="{ on: index == active }"
                @click="
                  device == 'mobile'
                    ? navToggle(index, item.url)
                    : changeNav(index, item.url)
                "
              >
                <a href="javascript:void(0);">{{ item.title }}</a>
              </li>
            </ul>
            <div class="button" v-if="islogin!= 1">
              <el-button
                type="primary"
                size="small"
                @click="$router.push('/login')"
                >登录</el-button
              >
              <el-button
                type="default"
                size="small"
                @click="$router.push('/register')"
                >注册</el-button
              >
            </div>
            <div class="button" v-else>
              <el-button
                type="primary"
                size="small"
                @click="loginout()"
                >退出登录</el-button
              >
            </div>
          </div>
        </div>
      </header>
      <header class="header" v-if="device == 'mobile'">
        <div class="container">
          <div class="logo_wrapper a_center">
            <div class="logo flex_full">
              <img
                :src="'static/images/pc/loginlogo.png'"
                class="logoImg"
                alt
                @click="toindex"
              />
            </div>
            <div class="button" v-if="islogin != 1">
              <el-button
                type="primary"
                size="small"
                @click="$router.push('/login')"
                >登录</el-button
              >
              <el-button
                type="default"
                size="small"
                @click="$router.push('/register')"
                >注册</el-button
              >
            </div>
            <div class="button" v-else>
              <el-button
                type="primary"
                size="small"
                style="width:1.2rem;"
                @click="loginout()"
                >退出登录</el-button
              >
            </div>
          </div>
          <div class="nav">
            <ul>
              <li
                v-for="(item, index) in nav"
                :key="index"
                :class="{ on: index == active }"
                @click="
                  device == 'mobile'
                    ? navToggle(index, item.url)
                    : changeNav(index, item.url)
                "
              >
                <a href="javascript:void(0);">{{ item.title }}</a>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
export default {
  name: "v_header",
  props: ["active"],
  inject: ["reload"],
  data() {
    return {
      nav: [
        {
          title: "首页",
          url: "/index"
        },
        {
          title: "关于我们",
          url: "/about"
        },
        {
          title: "宾果游戏",
          url: "/bingo"
        },
        // {
        //   title: "充值中心",
        //   url: "/recharge"
        // },
        {
          title: "人才招聘",
          url: "/recruitment"
        },
        {
          title: "家长监护",
          url: "/supervision"
        }
      ],
      bool: false,
      islogin:0
    };
  },
  watch: {
    $route(to, from) {
      this.nav.forEach((item, index) => {
        if (item.url == to.path) {
          window.localStorage.setItem("active", index);
          this.$emit("changeActive", index);
        }
      });
    }
  },
  created(){
    this.islogin = localStorage.getItem('islogin')
  },
  methods: {
    // 切换导航栏按钮
    changeNav(index, url) {
      this.$router.push(url).catch(err => {
        err;
      });
      // this.active=index;
      window.localStorage.setItem("active", index);
      this.$emit("changeActive", index);
    },
    toindex() {
      window.localStorage.setItem("active", 0);
      this.$emit("changeActive", 0);
      this.$router.push("/").catch(err => {
        err;
      });
    },
    navToggle(index, url) {
      var that = this;
      that.bool = !that.bool;
      if (that.bool) {
        $(".nav ul")
          .addClass("show")
          .removeClass("hide");
        $(".bg").fadeIn(350);
      } else {
        $(".nav ul")
          .addClass("hide")
          .removeClass("show");
        $(".bg").fadeOut(350);
      }
      if (url) {
        this.$router.push(url).catch(err => {
          err;
        });
        // this.active=index;
        window.localStorage.setItem("active", index);
        this.$emit("changeActive", index);
      }
    },
    loginout(){
      localStorage.removeItem('islogin')
      this.islogin = 0
      this.reload()
    }
  }
};
</script>

<style lang="less" scoped="scoped">
// pc样式
.header-pc {
  height: 90px;
  .header {
    width: 100%;
    height: 90px;
    line-height: 90px;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    font-size: 0;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .logo {
      // position: absolute;
      // left: 0;
      // top: 0;
      // z-index: 100;
      img {
        width: 230px;
        height: 60px;
      }
    }
    .nav {
      height: 100%;
      text-align: right;
      float: right;
      display: flex;
      align-items: center;
      ul {
        li {
          height: 56px;
          line-height: 56px;
          float: left;
          display: flex;
          align-items: center;
          a {
            display: block;
            // width: 114px;
            padding: 0 28px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            font-size: 16px;
            color: #393d41;
            border-radius: 15px;
            position: relative;
            &::after {
              content: "·";
              position: absolute;
              right: 0;
              font-size: 20px;
              color: #393d41;
            }
          }
          &:last-child a::after {
            font-size: 0;
          }
          &.on a,
          &:hover a {
            color: #0095ff;
          }
        }
      }
    }
    .button {
      display: flex;
      margin-left: 60px;
      .el-button {
        font-size: 16px;
      }
    }
  }
}
// mobile样式
@keyframes show {
  0% {
    height: 0;
  }
  100% {
    height: 3.99rem;
  }
}

@keyframes hide {
  0% {
    height: 3.99rem;
  }
  100% {
    height: 0;
  }
}
.bg {
  position: fixed;
  z-index: 1300;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.4;
}
.header-mobile {
  height: 2.0667rem;
  .header {
    width: 100%;
    height: 2.0667rem;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    font-size: 0;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    .container {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    .logo_wrapper {
      height: 1.2267rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .logo {
      margin-left: 0.4rem;
      img {
        width: 2.9067rem;
        height: 0.6933rem;
      }
    }
    .nav {
      height: 0.84rem;
      display: flex;
      align-items: center;
      ul {
        background: #2a3137;
        width: 100%;
        display: flex;
        justify-content: space-between;
        li {
          height: 0.84rem;
          line-height: 0.84rem;
          display: flex;
          align-items: center;
          a {
            display: block;
            // width: 114px;
            height: 0.4rem;
            text-align: center;
            line-height: 0.4rem;
            font-size: 0.2133rem;
            color: #c0c0c0;
            position: relative;
            margin: 0 0.36rem;
            &::after {
              content: "·";
              position: absolute;
              right: -0.48rem;
              font-size: 0.2667rem;
              color: #c0c0c0;
            }
          }
          &:last-child a::after {
            font-size: 0;
          }
          &.on a,
          &:hover a {
            color: #fff;
            border-bottom: 0.04rem solid #37b0e8;
          }
        }
      }
    }
    .button {
      display: flex;
      margin-left: 0.8rem;
      margin-right: 0.4rem;
      .el-button {
        font-size: 0.2133rem;
        width: 0.7733rem;
        height: 0.4267rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v_header.vue